<template>
    <div>
        <b-modal id="modal-Music" class="modal-form" :title="modal_title" @hidden="CLEAR_FORM()" centered hide-footer>
            <ValidationObserver ref="form">
                <validation-provider rules="required" v-slot="{ errors }">
                    <div class="form-group">
                        <label>Music Title</label>
                        <input v-model="formdata.title" type="text" class="form-control" name="name">
                        <div class="invalid-input">{{ errors[0] }}</div>
                    </div>
                </validation-provider>

                <!-- UPLOAD MUSIC ON EDIT -->
                <validation-provider v-if="!formdata.music_name" rules="required|mimes:audio/*" v-slot="{ errors, validate }">
                    <div class="form-group" v-if="!formdata.music_name">
                        <div class="mb-1">
                            <label>Your Music</label>
                        </div>
                        <div class="btn-up d-flex align-items-center" v-on:click.prevent="$refs.inputMusic.click()">
                            <div class="upload"><i class="uil uil-music mr-1"></i> ADD MUSIC</div>
                        </div>
                        <input ref="inputMusic" 
                                type="file"
                                class="custom-file-input d-none"
                                id="Thumbnail"
                                v-on:change="onMusicUpload"
                                accept="audio/mp3" 
                                @input="validate" >
    
                        <div class="invalid-input mt-3">{{ errors[0] }}</div>
                    </div>
                </validation-provider>
                
                <div class="form-group" v-if="formdata.music_name">   
                    <div class="mb-1">
                        <label>Music</label>
                    </div> 
                    <button v-on:click.prevent="removeMusicUpload()" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Music</button> 
                    <div class="input-group img-sh">
                        <div class="music-up d-flex">
                            <div class="music-ic">
                                <i class="w-100 uil uil-music mr-1"></i>
                            </div>
                            <div class="music-cnt ml-3 mt-1">
                                <div><strong>{{formdata.music_name}}</strong></div>
                                <div>{{formdata.music_size |formatSize}}</div>
                                <div>{{formdata.music_type}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="invalid-input mt-3">{{ errors[0] }}</div>
                </div>

                <div class="d-flex">
                    <label class="pl-0 custom-switch switch-big">
                        <input v-model="formdata.is_public" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                        <span class="custom-switch-indicator"></span>
                    </label>
                    <label class="mt-3 ml-3">
                        <span class="custom-switch-description ml-0"><strong>Music For Public</strong></span>
                        <p class="desc">This function is used to display music on all event</p>
                    </label>
                </div>
        
                <div class="button-modal text-right">
                    <button v-on:click="validationForm(formdata.id)" type="button" class="btn btn-new"  v-bind:class="loading ? 'btn-progress' : ''">
                        Save Data
                    </button>
                </div>
            </ValidationObserver>
        </b-modal>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import {ValidationProvider, ValidationObserver} from "vee-validate";

    export default{
        data(){
            return{
                loading:false,
                modal_title : 'Add Music',
                music_file:{},
            }
        },
        props: ['del_music'],
        components: {
            ValidationProvider,
            ValidationObserver,
        },
        computed: {
            ...mapState('MusicControl', {
                formdata: state => state.formdata,
                errors: state => state.errors
            }),
        },
        watch:{
            'formdata':function(val){
                if(val.id){
                    this.modal_title = 'Edit Music'
                }else if(!val.id){
                    this.modal_title = "Add Music"
                }
            },
        },
        filters: {
            formatSize: function(num){
                if (typeof num !== 'number' || isNaN(num)) {
                throw new TypeError('Expected a number');
                }

                var exponent;
                var unit;
                var neg = num < 0;
                var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                if (neg) {
                num = -num;
                }

                if (num < 1) {
                return (neg ? '-' : '') + num + ' B';
                }

                exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1);
                num = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
                unit = units[exponent];

                return (neg ? '-' : '') + num + ' ' + unit;
            }
        },
        methods: {
            ...mapActions('MusicControl', ['createMusic','updateMusic','changeStatusMusic']),
            ...mapMutations('MusicControl', ['CLEAR_FORM']),
            
            onMusicUpload: function(event) {
                var input = event.target;

                if (input.files && input.files[0]) {
                    this.formdata.music_name = input.files[0].name
                    this.formdata.music_size = input.files[0].size
                    this.formdata.music_type = input.files[0].type
                }
                this.music_file = input.files[0]
            },
            removeMusicUpload:function(){
                this.music_file = ''
                this.formdata.music_name = ''
                this.formdata.music_size = ''
                this.formdata.music_type = ''
            },
            validationForm: function(id) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        var formData = new FormData();
                        formData.append('title', this.formdata.title);
                        formData.append('is_public', this.formdata.is_public);
                        formData.append('music', this.music_file);
                        
                        if(id){
                            formData.append("_method", "put");
                            this.updateMusic(formData).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Music')
                                this.$emit('getMusic');
                                this.CLEAR_FORM()
                                this.$toast.success('Successfully Update Music')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            }) 

                        }else{

                            this.createMusic(formData).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Music')
                                this.$emit('getMusic');
                                this.CLEAR_FORM()
                                this.$toast.success('Successfully Added Music')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            }) 
                        }
                    }
                });
            },
        }
    }
</script>
